<section class="help-links" aria-label="Canales de ayuda">
  <p class="help-links__title">Necesitas que te ayudemos</p>

  <ul class="help-links__list">
    <li *ngFor="let link of links">
      <a
        class="help-links__link"
        [href]="link.url"
        [target]="link.target"
        [attr.rel]="link.target === '_blank' ? 'noopener noreferrer' : null"
        (click)="onLinkClick($event, link)"
      >
        {{ link.label }}
      </a>
    </li>
  </ul>
</section>